import type SignatureCanvas from 'react-signature-canvas';

export const signatureImport = async (
  file: File | Blob,
  sigCanvas: InstanceType<typeof SignatureCanvas>,
  fieldColor: string
) => {
  const url = URL.createObjectURL(file);
  const img = new Image();

  img.onload = async () => {
    try {
      const internalCanvas = sigCanvas.getCanvas();
      const width = internalCanvas.width;
      const height = internalCanvas.height;
      const ctx = internalCanvas.getContext('2d');
      if (!ctx) {
        throw new Error('No temp canvas context');
      }

      ctx.drawImage(img, 0, 0, width, height);

      ctx.globalCompositeOperation = 'source-in';
      ctx.fillStyle = fieldColor;
      ctx.fillRect(0, 0, width, height);
      ctx.globalCompositeOperation = 'source-over';
    } catch (err) {
      console.error('Signature import failed:', err);
    } finally {
      URL.revokeObjectURL(url);
    }
  };

  img.onerror = () => {
    URL.revokeObjectURL(url);
  };
  img.src = url;
};
